import img from '../../../img/sous1.svg'
import img2 from '../../../img/sous2.svg'
import img3 from '../../../img/sous3.svg'
import img4 from '../../../img/sous4.svg'


export const sousData = [
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#1'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#2'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#3'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#4'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        price: '475 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#5'
    },
    {
        img: img4,
        name: 'Тигр мама',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#6'
    },
    {
        img: img3,
        name: 'Супер Филадельфия',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#7'
    },
    {
        img: img,
        name: 'Филадельфия кранч',
        text: 'Семга, рис, сыр креметто, соус унаги, креветка, авокадо, чип...',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'sous#8'
    },

]